/**
 * What a person calls a step.
 *
 * The 166 steps seeded from Epicor have readable ids (a JobNum such as
 * 220142-DetM1). A step made in this tool gets a random one, and showing that on
 * a bar tells nobody anything. Those are named by their project and step name.
 * Decided by `origin`, never by parsing the id.
 */
export function stepLabel(
  phase: { phaseId: string; projectId: string; phaseCode: string | null; description: string | null; origin?: string } | undefined,
  fallbackId: string,
): string {
  if (!phase || phase.origin === "epicor") return phase?.phaseId ?? fallbackId;
  const name = (phase.phaseCode ?? "").trim() || phase.description || phase.phaseId;
  return `${phase.projectId} · ${name}`;
}
